import React from 'react';
import StationNodes from './StationNodes';
import StationStaple from './StationStaple';
import { stationSummaryNode } from '../utils/stationSummaryNode';

// eslint-disable-next-line complexity
function buildStationStyles(stationNodes, isSelectedStation) {
    const stationPadding = '10rem';
    const width = isSelectedStation
        ? `calc(9rem * ${stationNodes.length} + ${stationPadding})`
        : `calc(5rem + ${stationPadding})`;

    if (!isSelectedStation) {
        return { maxWidth: width, cursor: 'pointer' };
    }

    if (!isSelectedStation || stationNodes.length === 1) {
        return { maxWidth: width };
    }

    return { minWidth: width, maxWidth: width };
}

function getNodesToDisplay(stationNodes, isSelectedStation) {
    if (isSelectedStation) {
        return stationNodes;
    }
    return [stationSummaryNode(stationNodes)];
}

export default function Station(props) {
    const nodesToDisplay = getNodesToDisplay(
        props.nodes,
        props.isSelectedStation
    );

    return (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events
        <div
            key={props.stationCode}
            className="station"
            style={buildStationStyles(nodesToDisplay, props.isSelectedStation)}
            onClick={props.onStationClick}
        >
            <StationStaple station={props.stationCode} />
            <StationNodes
                nodes={nodesToDisplay}
                connectingNode={props.nodes[0]}
            />
        </div>
    );
}
